import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ApiService} from '../../../../core/service/api.service';

@Injectable()
export class ServiceProviderPriceService {

  constructor(private api:ApiService) { }

  getServiceProviderPrice(criteria): Observable<any> {
        return this.api.get('vna/service-provider-pricing',criteria);
  }

  postServiceProviderPrice(data: Object): Observable<any> {
        return this.api.post('vna/service-provider-pricing',data);
  }

  removeServiceProviderPrice(pk: any): Observable<any> {
        return this.api.remove('vna/service-provider-pricing', pk);
  }

  putServiceProviderPrice(element: any): Observable<any> {
        return this.api.put('vna/service-provider-pricing',element.pk,element);
  }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/services/service-provider-price.service.ts